<!-- Loader -->
<div
  *ngIf="PreLoader"
  class="bodyLoader"
  style="
    z-index: 9998;
    background-color: rgba(255, 255, 255, 0.7);
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  "
>
  <div
    class="loader"
    style="
      position: fixed;
      top: 49%;
      left: 49%;
      transform: translate(-50%, -50%);
      z-index: 9999;
    "
  >
    <svg viewBox="0 0 80 80">
      <circle id="test" cx="40" cy="40" r="32"></circle>
    </svg>
  </div>

  <a
    class="dribbble"
    href="https://dribbble.com/shots/5878367-Loaders"
    target="_blank"
    ><img
      src="https://cdn.dribbble.com/assets/dribbble-ball-mark-2bd45f09c2fb58dbbfb44766d5d1d07c5a12972d602ef8b32204d28fa3dda554.svg"
      alt=""
  /></a>
</div>

<!-- Main Container with Dynamic Background -->
<div class="bg-main" [ngStyle]="{'background-image': 'url(' + bgImageUrl + ')'}">
  
  <!-- Navbar -->
  <nav class="navbar custom-navbar">
    <div class="navbar-content p-3">
      <div class="welcome">
        <div class="welcome-badge">
          <small class="text-dark">Welcome: <b><span class="capitalize">{{ cname }}</span></b></small>
        </div>
      </div>

      <a class="navbar-logo" href="#">
        <img [src]="logoPath" alt="Logo">
      </a>

      <button class="btn btn-solid btn-sm" (click)="logout()">Log Out</button>
    </div>
  </nav>

  <!-- Main Content -->
  <main class="main-content">
    <div class="content-wrapper">
      
      <!-- Customer Selection Panel -->
      <div class="panel customer-panel">
        <form (ngSubmit)="onSubmit()" class="form-content">
          <h6 class="form-title">SELECT CUSTOMER</h6>
          
          <select
            class="form-control"
            (change)="selectCountry($event.target.value)"
            required
          >
            <option value="">-- Choose Customer --</option>
            <option *ngFor="let customer of customersList" [value]="customer.id">
              {{ customer.displayName }}
            </option>
          </select>

          <button
            class="btn btn-solid w-100 mt-3"
            type="submit"
            [disabled]="!selectedCustomer"
          >
            NEXT
          </button>

          <div class="info-box">
            <small>
              <strong>📌 Note:</strong> To approve any customer's order, first select the customer and click NEXT, then click on the Awaiting Approval Orders button to go to that page and process the order from there.
            </small>
          </div>
        </form>
      </div>

      <!-- Orders Panel -->
      <div class="panel orders-panel">
        
        <!-- Header -->
        <div class="panel-header">
          <h6 class="mb-0">
            <i class="fas fa-hourglass-start"></i> Awaiting Approval
          </h6>
          <span class="badge">{{ awaitingOrders?.length || 0 }}</span>
        </div>

        <!-- Content -->
        <div class="panel-body">
          
          <!-- Desktop Table -->
          <div class="table-desktop">
            <table class="table">
              <thead>
                <tr>
                  <th>ORDER ID</th>
                  <th>CUSTOMER</th>
                  <th class="text-end">AMOUNT</th>
                  <th class="text-center">DATE</th>
                  <!-- <th>STATUS</th> -->
                  <th class="text-center">ACTION</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let order of awaitingOrders">
                  <td class="fw-bold text-primary">{{ order.orderID || order.id }}</td>
                  <td>{{ order.customerName }}</td>
                  <td class="text-end text-success fw-bold">{{ order.totalAmountIncludingTax | currency }}</td>
                  <td class="text-center small text-muted">{{ order.createdOnUTC | date: 'MM-dd-yyyy' }}</td>
                  <!-- <td><span class="badge">Awaiting Approval</span></td> -->
                  <td class="text-center">
                    <button
                      class="btn-view"
                      (click)="viewOrderDetails(order)"
                      data-bs-toggle="modal"
                      data-bs-target="#orderDetailsModal"
                    >
                      VIEW
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div *ngIf="!awaitingOrders || awaitingOrders.length === 0" class="empty-state">
              <i class="fas fa-inbox"></i>
              <p>No pending orders</p>
            </div>
          </div>

          <!-- Mobile Cards -->
          <div class="cards-mobile">
            <div *ngFor="let order of awaitingOrders" class="order-card">
              <div class="card-header">
                <div class="card-id">Order <strong>{{ order.orderID || order.id }}</strong></div>
                <span class="badge">Awaiting Approval</span>
              </div>
              <div class="card-body">
                <p class="customer">{{ order.customerName }}</p>
                <div class="row-data">
                  <div class="data-item">
                    <span class="label">Amount</span>
                    <span class="value text-success">{{ order.totalAmountIncludingTax | currency }}</span>
                  </div>
                  <div class="data-item">
                    <span class="label">Date</span>
                    <span class="value">{{ order.createdOnUTC | date: 'dd-MMM' }}</span>
                  </div>
                </div>
              </div>
              <button
                class="btn-view-mobile"
                (click)="viewOrderDetails(order)"
              >
                View Details
              </button>
            </div>
            <div *ngIf="!awaitingOrders || awaitingOrders.length === 0" class="empty-state">
              <i class="fas fa-inbox"></i>
              <p>No pending orders</p>
            </div>
          </div>

        </div>
      </div>

    </div>
  </main>

</div>

<!-- Order Details Modal - ng-bootstrap version -->
<ng-template #orderDetailsModal let-modal>
  <div class="modal-header">
    <h6 class="modal-title fw-bold">Order {{ selectedOrderForView?.orderID || selectedOrderForView?.id }}</h6>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div *ngIf="selectedOrderForView">
      
      <div class="modal-info">
        <div class="info-row">
          <span class="label">Customer:</span>
          <span class="value">{{ selectedOrderForView.customerName }}</span>
        </div>
        <div class="info-row">
          <span class="label">Amount:</span>
          <span class="value text-success fw-bold">{{ selectedOrderForView.totalAmountIncludingTax | currency }}</span>
        </div>
        <div class="info-row">
          <span class="label">Date:</span>
          <span class="value">{{ selectedOrderForView.createdOnUTC | date: 'dd-MMM-yyyy HH:mm' }}</span>
        </div>
        <div class="info-row">
          <span class="label">Status:</span>
          <span><span class="badge">{{ selectedOrderForView.orderStatus }}</span></span>
        </div>
      </div>

      <hr>

      <h6 class="fw-bold mb-3">Items</h6>
      <div class="table-responsive">
        <table class="table table-sm table-bordered">
          <thead class="table-light">
            <tr>
              <th>#</th>
              <th>Description</th>
              <th class="text-center">Qty</th>
              <th class="text-end">Price</th>
              <th class="text-end">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of selectedOrderForView._OrderDetail_dto; let i = index">
              <td>{{ i + 1 }}</td>
              <td class="small">{{ item.description }}</td>
              <td class="text-center">{{ item.quantity }}</td>
              <td class="text-end">{{ item.unitPrice | currency }}</td>
              <td class="text-end fw-bold">{{ (item.quantity * item.unitPrice) | currency }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>